module.exports = __webpack_public_path__ + "img/setup.3ddae3e7.png";